import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CityService} from '@services/city.service';
import {AdService} from '@services/ad.service';
import {CommonService} from '@services/common.service';
import {Favorite} from '@models/favorite';
import {AuthenticationService} from '@services/authentification.service';
import {MatDialog} from '@angular/material/dialog';

@Component({
    selector: 'app-revenus',
    templateUrl: './revenus.component.html',
    styleUrls: ['./revenus.component.scss']
})
export class RevenusComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() favoriteChange = new EventEmitter();

    rentChoice = [];

    constructor(
        public cityService: CityService,
        public adService: AdService,
        public dialog: MatDialog,
        public commonService: CommonService,
        public authenticationService: AuthenticationService) {

    }

    edit(fields = '') {
        if (fields === 'furnish') {
            this.favorite.lots.forEach(lot => {
                if (lot.furnish == 3) {
                    // LCD
                    lot.amount_copro_rent = 0;
                    lot.advice_rent_choice = '';
                    lot.amount_rent = 0;
                } else if (lot.furnish == 4) {
                    // Coloc
                    lot.advice_rent_choice = "city.loyer_moyen_ville.C";
                    lot.nb_lots = (this.favorite.rooms >= 2 ? this.favorite.rooms - 1 : this.favorite.rooms);
                } else {
                    if (this.cityService.rentFields[lot.advice_rent_choice] == undefined) {
                        lot.advice_rent_choice = 'city.loyer_moyen_petite_ville';
                    }
                    lot.advice_rent_choice = lot.advice_rent_choice.replace('_non_meuble', '');
                    lot.advice_rent_choice = lot.advice_rent_choice.replace('_meuble', '');
                    if (lot.furnish === 1) {
                        lot.advice_rent_choice = lot.advice_rent_choice.replace('_ville.A', '_ville_meuble.A');
                        lot.advice_rent_choice = lot.advice_rent_choice.replace('_ville.M', '_ville_meuble.M');
                        lot.advice_rent_choice = lot.advice_rent_choice.replace('_piece[', '_piece_meuble[');
                    } else if (lot.furnish === 2) {
                        lot.advice_rent_choice = lot.advice_rent_choice.replace('_ville.A', '_ville_non_meuble.A');
                        lot.advice_rent_choice = lot.advice_rent_choice.replace('_ville.M', '_ville_non_meuble.M');
                        lot.advice_rent_choice = lot.advice_rent_choice.replace('_piece[', '_piece_non_meuble[');
                    }
                }
            });
            this.refreshRentChoice();
        }

        if (fields === 'night_number' || fields == 'night_price') {
            this.favorite.lots.forEach(lot => {
                if (lot.furnish == 3) {
                    lot.amount_rent = lot.night_number * lot.night_price;
                }
            });
        }

        if (this.favorite.lots.length === 1) {
            this.favorite.rooms = this.favorite.lots[0].rooms;
            this.favorite.square = this.favorite.lots[0].square;
            this.favorite.amount_rent = this.favorite.lots[0].amount_rent;
            this.favorite.amount_copro_rent = this.favorite.lots[0].amount_copro_rent;
            this.favorite.advice_rent = this.favorite.lots[0].advice_rent;
            this.favorite.advice_rent_choice = this.favorite.lots[0].advice_rent_choice;
            this.favorite.advice_rent_L = this.favorite.lots[0].advice_rent_L;
            this.favorite.advice_rent_U = this.favorite.lots[0].advice_rent_U;
            this.favorite.furnish = this.favorite.lots[0].furnish;
        }

        this.favorite = this.adService.cleanInput(this.favorite);
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }

    ngOnInit() {
        this.favorite = this.adService.updateValues(this.favorite)
        this.refreshRentChoice();
    }

    // Une entrée par lot, même en LCD/colocation : le template lit rentChoice[i] avec l'index du lot.
    private refreshRentChoice() {
        this.rentChoice = this.favorite.lots.map(lot => this.cityService.getRentChoice(this.favorite.ad_city, lot.furnish));
    }

    getDisplaySquare(lot): number {
        if (this.favorite.square > 0) {
            return this.favorite.square;
        }
        const p = this.cityService.getRentValue(this.favorite.ad_city, lot.advice_rent_real || lot.advice_rent_choice);
        return p ? p.s_moy : 0;
    }

    applyRent(value, i) {
        this.favorite.lots[i].amount_rent = value
        if (this.favorite.lots.length === 1) {
            this.favorite.amount_rent = this.favorite.lots[0].amount_rent;
        }
        this.favorite = this.adService.updateValues(this.favorite);
        this.favoriteChange.emit();
    }
}
